// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "price-2UlRg";
var _3 = "edit-2K98c";
var _4 = "button-2-6FP";
export { _1 as "__esModule", _2 as "price", _3 as "edit", _4 as "button" }
export default { "__esModule": _1, "price": _2, "edit": _3, "button": _4 }
